var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlucsDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6.312 7.215"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flucs-down_svg__Icon_-_Arrow_Down_Small",
    "data-name": "Icon - Arrow Down Small",
    transform: "rotate(180 79.156 294.054)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "flucs-down_svg__Path_5615",
    "data-name": "Path 5615",
    d: "M.53 3.528l2.625 2.626 2.626-2.626",
    transform: "rotate(180 79.156 294.053)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "flucs-down_svg__Line_1119",
    "data-name": "Line 1119",
    transform: "rotate(180 77.578 294.054)",
    d: "M0 6.154L.001 0"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2LjMxMiA3LjIxNSI+Cgk8ZyBpZD0iSWNvbl8tX0Fycm93X0Rvd25fU21hbGwiIGRhdGEtbmFtZT0iSWNvbiAtIEFycm93IERvd24gU21hbGwiCgkJdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMTU4LjMxMiA1ODguMTA4KSByb3RhdGUoMTgwKSI+CgkJPHBhdGggaWQ9IlBhdGhfNTYxNSIgZGF0YS1uYW1lPSJQYXRoIDU2MTUiIGQ9Ik0uNTMsMy41MjgsMy4xNTUsNi4xNTQsNS43ODEsMy41MjgiCgkJCXRyYW5zZm9ybT0idHJhbnNsYXRlKDE1OC4zMTIgNTg4LjEwNykgcm90YXRlKDE4MCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIgoJCQlzdHJva2Utd2lkdGg9IjEuNSIgLz4KCQk8bGluZSBpZD0iTGluZV8xMTE5IiBkYXRhLW5hbWU9IkxpbmUgMTExOSIgeTE9IjYuMTU0IiB4Mj0iMC4wMDEiCgkJCXRyYW5zZm9ybT0idHJhbnNsYXRlKDE1NS4xNTYgNTg4LjEwOCkgcm90YXRlKDE4MCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iY3VycmVudENvbG9yIgoJCQlzdHJva2Utd2lkdGg9IjEuNSIgLz4KCTwvZz4KPC9zdmc+";
export { SvgFlucsDown as ReactComponent };